import { ActionIcon, Flex } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

type ContentHeaderProps = {
  backHref?: string;
  left?: React.ReactNode;
  right?: React.ReactNode;
};

export default function ContentHeader({ backHref, left, right }: ContentHeaderProps) {
  return (
    <Flex align="center" justify="space-between">
      <Flex align="center" gap={16}>
        {backHref && (
          <ActionIcon variant="subtle" component={Link} to={backHref} c="black">
            <IconArrowLeft size={16} />
          </ActionIcon>
        )}
        {left}
      </Flex>
      <Flex align="center">{right}</Flex>
    </Flex>
  );
}
